import Yup from '../../../yup-extended';

export default Yup.object({
  retainDataForInDays: Yup.number()
    .moreThan(0, 'Must be greater than 0')
    .required('Please enter the number of days'),
  autoSignOutInHours: Yup.number()
    .moreThan(0, 'Must be between 1 and 24 hours')
    .lessThan(25, 'Must be between 1 and 24 hours')
    .required('Please enter the number of hours'),
});
